import React, { useCallback, useEffect } from "react";
import { Menu, Dropdown, Icon, Label } from "semantic-ui-react";
import { NavLink, Link, useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import * as actionCreators from "./actions";
import { updateReadedNotify } from "./../Notification/actions";

export function HeaderContainer() {
    const { headerStore, notificationStore } = useSelector((state) => {
        return {
            headerStore: state.header,
            companyStore: state.companyList,
            companyGroupStore: state.companyGroupStore,
            notificationStore: state.notificationStore,
        };
    });
    const dispatch = useDispatch();
    const history = useHistory();


    useEffect(() => {
        if (headerStore.logOut) {
            window.localStorage.clear();
            window.location.href = "login.html";
        }
    }, [headerStore.logOut]);



    const handlerNotificationClick = useCallback(
        (e, data) => {
            var notify = notificationStore.list.find((x) => x.id == data.eventKey);
            if (!notify) {
                return;
            }

            dispatch(updateReadedNotify({ id: notify.id }));
            if (notify.code == "order") {
                const { orderId, companyId } = notify.data;
                history.push(`/Company/${companyId}/Order/${orderId}`);
            }
        },
        [notificationStore.list]
    );

    return (
        <Menu fixed="top" fluid inverted size="huge" borderless>
            <Menu.Item as={Link} to={"/"} header>
                Моя доска
            </Menu.Item>
            <Menu.Item header id="toggle-sidebar">
                <Icon name="sidebar" />
            </Menu.Item>
            <Menu.Item
                link
                header
                onClick={() => {
                    history.goBack();
                }}>
                <Icon name="arrow left" /> Назад
            </Menu.Item>
            <Menu.Menu position="right">

                <Dropdown
                    pointing
                    className="link item"
                    icon={"mail"}
                    scrolling
                    text={
                        <Label color={notificationStore.list.length > 0 ? "orange" : null}>
                            {" "}
                            {notificationStore.list.length}
                        </Label>
                    }>
                    <Dropdown.Menu>
                        {notificationStore.list.map((x) => (
                            <Dropdown.Item
                                key={x.id}
                                eventKey={x.id}
                                onClick={handlerNotificationClick}>
                                <h4>{x.title}</h4>
                                {x.message}
                            </Dropdown.Item>
                        ))}
                        {!notificationStore.list.length && (
                            <Dropdown.Item>Сообщений нет</Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                </Dropdown>

                {localStorage.getItem("roles") == "Admin" && (
                    <Dropdown item icon="user secret">
                        <Dropdown.Menu>
                            <Dropdown.Item
                                as={NavLink}
                                to="/Admin/Account"
                                activeClassName="active">
                                Все пользователи
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={NavLink}
                                to="/Admin/Company"
                                activeClassName="active">
                                Все Компании
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={NavLink}
                                to={"/Admin/RoleCompany"}
                                activeClassName="active">
                                Роли Компаний
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={NavLink}
                                to={"/Admin/Permission"}
                                activeClassName="active">
                                Permission
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={NavLink}
                                to={"/Admin/Account/Session"}
                                activeClassName="active">
                                Сессии
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={NavLink}
                                to={"/Admin/Metric"}
                                activeClassName="active">
                                Статистика
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={NavLink}
                                to={"/Admin/Error"}
                                activeClassName="active">
                                Ошибки системы
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={NavLink}
                                to={"/Admin/Printer/Queue"}
                                activeClassName="active">
                                Очередь печати
                            </Dropdown.Item>
                            <Dropdown.Item
                                as={NavLink}
                                to={"/Admin/Notification/all"}
                                activeClassName="active">
                                Все сообщения нотификации
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                )}

                <Dropdown item text="Мой профиль">
                    <Dropdown.Menu>
                        <Menu.Item
                            icon="user circle"
                            link
                            as={Link}
                            to={"/Account/" + localStorage.getItem("userId")}
                            name="Мой профайл"
                        />
                        <Menu.Item
                            icon="user circle"
                            link
                            as={Link}
                            to={"/Account/" + localStorage.getItem("userId") + "/Session"}
                            name="Сесии"
                        />
                        <Menu.Item
                            icon="user circle"
                            link
                            as={Link}
                            to={"/Account/" + localStorage.getItem("userId") + "/Notification"}
                            name="Сообщения"
                        />
                        <Menu.Item
                            icon="building outline"
                            link
                            as={Link}
                            to="/Company"
                            name="Мои Компании"
                        />
                        <Menu.Item
                            icon="user circle"
                            link
                            as={Link}
                            to={"/CompanyGroup"}
                            name="Мои группы компаний"
                        />
                        <Menu.Item
                            icon="sign out"
                            link
                            href="/login.html"
                            onClick={() => dispatch(actionCreators.LogOut())}
                            name="Выход"
                        />
                    </Dropdown.Menu>
                </Dropdown>
            </Menu.Menu>
        </Menu>
    );
}
